import { parseISO } from "date-fns";
import VehicleDomain, {
  GovInspectionDomain,
  ServiceDomain,
  VehicleMakeAndModel,
  VehicleRegistrationDomain,
} from "entities/domain/vehicle";
import {
  VehicleHealthDataDomain,
  VehicleHealthItem,
} from "entities/domain/vehicle/healthData";
import {
  GovInspectionDTO,
  ServiceDTO,
  VehicleDTO,
  VehicleRegistrationDTO,
} from "entities/dto/VehicleDTO";
import { VehicleHealthDataDTO } from "entities/dto/VehicleHealthDataDTO";
import { VehicleMakeAndModelDTO } from "entities/dto/VehicleMakeAndModelDTO";

const timestampToDate = (timestamp: string): Date =>
  parseISO(timestamp.includes("Z") ? timestamp : `${timestamp}Z`);

const vehicleRegistrationTransformFromDtoToDomain = (
  registration: VehicleRegistrationDTO
): VehicleRegistrationDomain =>
  new VehicleRegistrationDomain(
    registration.first_registration_date,
    registration.registration_date
  );

const govInspectionTransformFromDtoToDomain = (
  govInspection: GovInspectionDTO
): GovInspectionDomain =>
  new GovInspectionDomain(
    govInspection.last_date,
    govInspection.due_date,
    govInspection.due_date_source
  );

const serviceTransformFromDtoToDomain = (service: ServiceDTO): ServiceDomain =>
  new ServiceDomain(service.last_date, service.due_date);

export const vehicleMakeAndModelTransformFromDtoToDomain = (
  makeAndModel: VehicleMakeAndModelDTO
): VehicleMakeAndModel =>
  new VehicleMakeAndModel(makeAndModel.name, makeAndModel.models);

export const vehicleTransformFromDtoToDomain = (
  vehicle: VehicleDTO
): VehicleDomain =>
  new VehicleDomain(
    vehicle.id,
    vehicle.merchant_id,
    vehicle.customer_ids,
    vehicle.vin || "",
    vehicle.make || "",
    vehicle.model || "",
    vehicle.class || "",
    vehicle.year,
    vehicle.license_plate || "",
    vehicle.description || "",
    vehicle.variant || "",
    vehicle.interior_color || "",
    vehicle.exterior_color || "",
    vehicle.created_at || "",
    vehicle.updated_at || "",
    vehicle.registration
      ? vehicleRegistrationTransformFromDtoToDomain(vehicle.registration)
      : null,
    vehicle.gov_inspection
      ? govInspectionTransformFromDtoToDomain(vehicle.gov_inspection)
      : null,
    vehicle.service ? serviceTransformFromDtoToDomain(vehicle.service) : null,
    vehicle.sales_order_type || null,
    vehicle.date_of_last_work || null,
    vehicle.delivery_date || null,
    vehicle.invoice_date || null
  );

export const vehicleHealthDataTransformFromDtoToDomain = (
  vehicleHealthData: VehicleHealthDataDTO
): VehicleHealthDataDomain =>
  new VehicleHealthDataDomain(
    vehicleHealthData.vehicle_id,
    timestampToDate(vehicleHealthData.timestamp),
    vehicleHealthData.location_name,
    vehicleHealthData.total_distance,
    vehicleHealthData.overdue as VehicleHealthItem[] | null,
    vehicleHealthData.due as VehicleHealthItem[] | null,
    vehicleHealthData.created_at
      ? timestampToDate(vehicleHealthData.created_at)
      : null,
    vehicleHealthData.updated_at
      ? timestampToDate(vehicleHealthData.updated_at)
      : null
  );
